import moment from 'moment';
import {RouteType} from "./routes";
import {showlog} from "./utils/dev-utils";
import {WelcomePage} from "./pages/welcome/welcome-page";
import React from "react";


type cacheType = {
	currentPageData?: any;
	error?: any;
	currentPage?: RouteType;
}

export let cache: cacheType = {
	// currentPage: routes[0]
};

export const cachelog = () => {
	showlog(
		'%c  CACHE  ',
		'background:#f0f; color:#eee; border-radius:100px; font-weight: bold; font-size: 1.2em;',
	);
	showlog( cache );
}



export const DEFAULT_COMPANY_LOGO: string = '/imgs/---';



